import { render } from "./CreateLocationModal.vue?vue&type=template&id=af725b60"
import script from "./CreateLocationModal.vue?vue&type=script&lang=js"
export * from "./CreateLocationModal.vue?vue&type=script&lang=js"

import "./CreateLocationModal.vue?vue&type=style&index=0&id=af725b60&lang=css"
import "./CreateLocationModal.vue?vue&type=style&index=1&id=af725b60&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__